<template>
  <div :class="'card card-circle-chart ' + color">
    <div class="card-header text-center">
      <strong style="font-size: 17px" class="card-title"
        >{{ title
        }}<span v-if="pendiente" style="color: red; font-size: 18px"
          >*</span
        ></strong
      >
      <p class="description" style="color: grey">{{ description }}</p>
      <p class="pendienteEvaluar" style="color: grey">{{ pendienteEvaluar }}</p>
    </div>
    <div class="card-content" v-if="confidencial == false">
      <div v-if="percentage != '--'">
        <div class="chart-circle" :data-percent="percentage" ref="chart">
          {{ percentage }}%
        </div>
      </div>
      <div v-else>
        <div class="chart-circle" :data-percent="percentage" ref="chart">
          {{ percentage }}
        </div>
      </div>
    </div>
    <div v-else class="card-content">
     <center>
       <br> <br>
        <img
        src="static/img/ICONOS/candado.svg"
        class="img-responsive"
        width="70"
        alt="Imagen de bloqueo de HC avanti"
      />
     </center>
     <p>Confidencial</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "circle-chart-card",
  props: {
    color: {
      type: String,
      default: "blue",
    },
    bar: {
      type: String,
      default: "#b8d8d8",
    },
    confidencial: {
      type: Boolean,
      default: false,
    },
    percentage: "",
    pendiente: {
      type: Boolean,
      default: false,
    },
    pendienteEvaluar: "",
    title: String,
    description: String,
  },
  data() {
    return {
      chartId: "no-id",
      chart: null,
    };
  },
  methods: {
    updateChartId() {
      var currentTime = new Date().getTime().toString();
      var randomInt = this.getRandomInt(0, currentTime);
      this.chartId = `div_${randomInt}`;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    renderChart(EasyPieChart) {
      /* eslint-disable no-new */
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 10,
        size: 160,
        scaleColor: false,
        trackColor: "rgba(255,255,255,.25)",
        barColor: this.bar,
        animate: { duration: 1000, enabled: true },
      });
    },
  },
  async mounted() {
    this.updateChartId();
    let EasyPieChart = await import("easy-pie-chart");
    this.renderChart(EasyPieChart);
  },
  watch: {
    percentage: function (newVal) {
      if (this.chart) {
        this.chart.update(newVal);
      }
    },
  },
};
</script>
<style scoped>
.card-title {
  font-size: 13px;
}

.blue {
  border: 2px solid #b8d8d8;
}

.orange {
  border: 2px solid #ff8f5e;
}

.green {
  border: 2px solid #d5e5a3;
}

.brown {
  border: 2px solid #d6c1ab;
}

.description {
  color: grey !important;
}
.pendienteEvaluar {
  color: grey !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Cards/CircleChartCard.vue